import { useState } from "react";
import ExamplesMenu from "../examplesMenu/examplesMenu";
import ExamplesResults from "../examplesResults/examplesResults";
import styles from "./examplesWrapper.module.scss";

const ExamplesWrapper = ({ type, t }) => {
	const title = { photo: "Try Photo into Painting", interior: "Try Interior Redesign", text: "Try AI Image Generator" };
	const [activeList, setActiveList] = useState(null);

	return (
		<section className={styles.section}>
			<h2 className={styles.title}>{t["explore_what_it_can_become"]}</h2>
			<div className={styles.wrapper}>
				<ExamplesMenu type={type} setActiveList={setActiveList} activeList={activeList} t={t} />
				<ExamplesResults type={type} activeList={activeList} t={t} />
			</div>
		</section>
	);
};

export default ExamplesWrapper;
